import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { CategoryProfitRequest, CategoryResponse } from 'src/app/models/category.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { CategoryService } from 'src/app/services/category.service';
import { PriceService } from 'src/app/services/price.service';

@Component({
  selector: 'app-profit-margin',
  templateUrl: './profit-margin.component.html',
  styleUrls: ['./profit-margin.component.scss']
})
export class ProfitMarginComponent implements OnInit {

  categorySelected = null;
  categories: CategoryResponse[] = [];
  creating = false;
  edit = 0;
  alwaysCreating = false;
  pagination = {
    total: [],
    filter: [],
    pageSize: 5,
    startElement: 0,
    lastElement: 0,
    pageIndex: 0
  }
  editSubfamily: { [key: number]: number } = {};
  loading: { [key: number]: boolean } = {};
  editFamily: { [key: number]: number } = {};
  profits: { [key: number]: number } = {};
  priceSelected: number = -1;
  pricelists = [];
  savingAll = false;

  constructor(
    private categoryService: CategoryService,
    private toastService: ToastrService,
    private priceService: PriceService
  ) {

  }

  ngOnInit(): void {
    this.getPriceLists();
  }

  getPriceLists() {
    this.priceService.getPriceLists().subscribe({
      next: (response: ResponseObject) => {
        this.pricelists = response.data
      },
      error: (error: any) => {
        this.toastService.error(error.error.message);
      }
    })
  }

  changingPriceList() {
    if (this.priceSelected == -1) {
      this.categories = [];
      this.pagination.total = this.categories;
      this.resetPagination();
    } else {
      this.getCategories();
    }
  }

  getCategories() {
    this.profits = {};
    this.editFamily = {};
    this.editSubfamily = {};
    this.categoryService.getCategories().subscribe({
      next: (response: ResponseObject) => {
        this.categories = response.data as CategoryResponse[];
        this.categoryService.getCategoriesProfit().subscribe({
          next: (response: ResponseObject) => {
            var profits = response.data;
            profits = profits.filter((p)=>{
              return p.priceList == this.priceSelected
            });
            profits.forEach((p) => {
              this.profits[p.categoryId] = p.profitPercentage;
            })
            this.categories.forEach((c) => {
              if (!this.profits[c.id]) {
                this.profits[c.id] = 0;
              }
              c.children.forEach((children) => {
                if (!this.profits[children.id]) {
                  this.profits[children.id] = 0;
                }
              })
            })
            this.pagination.total = this.categories;
            this.resetPagination();
          },
          error: (error: any) => {
            this.toastService.error(error.error.message);
          }
        })
      },
      error: (error: any) => {
        this.toastService.error(error.error.message);
      }
    })
  }

  editProfitSubfamily(subfamily: any) {
    if (this.editSubfamily[subfamily.id] != undefined) {
      return;
    }
    this.editSubfamily[subfamily.id] = this.profits[subfamily.id];
  }

  getShowSaveChanges() {
    return Object.keys(this.editFamily).length > 1 || Object.keys(this.editSubfamily).length > 1
  }

  getLoadingChanges() {
    return Object.keys(this.loading).length !== 0
  }

  editProfitFamily(category: CategoryResponse) {
    if (this.editFamily[category.id] != undefined) {
      return;
    }
    this.editFamily[category.id] = this.profits[category.id];
  }

  saveProfitOfSingleCategory(category: number, profit: number) {
    if (this.loading[category]) {
      return;
    }
    this.loading[category] = true;
    var tempCategory = new CategoryProfitRequest(category, profit, this.priceSelected);
    this.saveProfit([tempCategory]);
  }

  saveProfit(categoryProfits: CategoryProfitRequest[]) {
    this.categoryService.addProfitToCategory(categoryProfits).subscribe({
      next: (response: ResponseObject) => {
        this.toastService.success("Datos de profit almacenados correctamente.");
        categoryProfits.forEach((c) => {
          if (this.loading[c.category]) {
            delete this.loading[c.category];
            if (this.editSubfamily[c.category] != undefined) {
              this.profits[c.category] = this.editSubfamily[c.category];
              delete this.editSubfamily[c.category];
            }
            if (this.editFamily[c.category] != undefined) {
              this.profits[c.category] = this.editFamily[c.category];
              delete this.editFamily[c.category];
            }
          }
        })
      },
      error: (error: any) => {
        this.toastService.error("Error en enviar datos.");
      }
    })
  }

  saveAllProfits() {
    var categoryProfits: CategoryProfitRequest[] = [];
    for (const key in this.editFamily) {
      this.loading[key] = true;
      if (this.editFamily[key] != this.profits[key] && this.editFamily[key] > 0) {
        categoryProfits.push(new CategoryProfitRequest(parseInt(key), this.editFamily[key], this.priceSelected));
      } else {
        delete this.editFamily[key];
        delete this.loading[key];
      }
    }
    for (const key in this.editSubfamily) {
      this.loading[key] = true;
      if (this.editSubfamily[key] != this.profits[key] && this.editSubfamily[key] > 0) {
        categoryProfits.push(new CategoryProfitRequest(parseInt(key), this.editSubfamily[key], this.priceSelected));
      } else {
        delete this.editSubfamily[key];
        delete this.loading[key];
      }
    }
    this.saveProfit(categoryProfits);
  }

  resetPagination() {
    this.pagination.filter = this.pagination.total.slice(0, this.pagination.pageSize);
    this.pagination.pageIndex = 0;
    this.pagination.lastElement = this.pagination.filter.length;
    this.pagination.startElement = 0;
  }

}
